import {useEffect, useLayoutEffect, useRef, useState} from 'react'
import {useNavigate, useParams} from 'react-router-dom'

import OverallProgress from '../OverallProgress'
import {initialRouteDocumentationPage} from '~/components/documentation/ApiPage'
import {interfaceLanguage} from '~/services/intl'
import {delay} from '~/utils/delay'
import {getStaticResourceText} from '~/utils/staticResource'

const copyText = (section: Element) => navigator.clipboard.writeText(section.textContent || '')
    .then(() => section.setAttribute('data-copied', 'true'))
    .then(() => delay(2000))
    .then(() => section.removeAttribute('data-copied'))

export default function() {
    const {topic = ''} = useParams()
    const [text, setText] = useState('')
    const navigate = useNavigate()
    const documentContent = useRef<HTMLDivElement>(null)

    useLayoutEffect(
        () => {
            getStaticResourceText(`/documentation/${topic}.${interfaceLanguage}.html`)
                .then(setText)
                .catch(() => navigate(initialRouteDocumentationPage))
                .finally(() => documentContent.current?.scrollIntoView({behavior: 'instant'}))
        },
        [navigate, topic]
    )

    useEffect(
        () => {
            const codeSections = documentContent.current?.querySelectorAll('[data-copy]') || []

            const unsubscribers = [...codeSections].map(section => {
                const copy = () => copyText(section)
                section.querySelector('button')?.addEventListener('click', copy)
                return () => section.querySelector('button')?.removeEventListener('click', copy)
            })

            return () => unsubscribers.forEach(unsubscriber => unsubscriber())
        },
        [text]
    )

    if (!text)
        return (
            <div className='documentation__text'>
                <OverallProgress/>
            </div>
        )

    return (
        <div className='documentation__text'>
            <div className='documentation__text-wrapper DocumentationContainer'>
                <div className='row row_top row_gap-10 row_nowrap'>
                    <div
                        className='documentation__text-content'
                        dangerouslySetInnerHTML={{__html: text}}
                        ref={documentContent}
                    />
                    {/* TODO доработать сабменю */}
                    {/* {documentElement && <DocumentationSubmenu content={documentElement}/>} */}
                </div>
            </div>
        </div>
    )
}
